let moneyValue
let goalValue
let defaultCurrency = 'CHF'
let dataTimeout

function getLocale () {
  return window.backend_properties.locale
}

function getCountry () {
  const locale = getLocale()
  if (locale && (locale.toLocaleLowerCase().includes('gb') || locale.toLocaleLowerCase().includes('uk'))) {
    return 'gb'
  } else {
    return (locale.split('_').length > 1 ? locale.split('_')[1] : locale).toLocaleLowerCase()
  }
}

// initialize with default values
async function init () {
  const moneyDefault = 15000
  let moneyMin = 500
  let moneyMax = 25000
  const moneyStep = 100

  const goalDefault = 90
  let goalMin = 15
  let goalMax = 90
  const goalStep = 1

  let sliderInterval

  function cleanLabels (id, defaultNo) {
    const elem = document.getElementById(id)
    const cleanRegex = new RegExp('\\D', 'g')
    const innertext = elem.innerHTML.replace(cleanRegex, '')
    if (innertext) {
      return parseInt(innertext, 10)
    } else {
      elem.innerText = formatNumber(defaultNo)
      return defaultNo
    }
  }

  function initializeElements (sliderId, inputId, def, min, max, step, val) {
    function setVals (elem) {
      elem.min = unformatNumber(min)
      elem.max = unformatNumber(max)
      elem.step = unformatNumber(step)
      elem.value = elem.type === 'range' ? unformatNumber(def) : formatNumber(def)
    }

    function setVariableSlider (newVal) {
      inputElem.value = formatNumber(newVal)
      newVal = unformatNumber(newVal)
      if (newVal >= sliderElem.min && newVal <= sliderElem.max) {
        setTopLevelValue(newVal, sliderId.split('-')[1])
        setSlider()
        setSliderBg()
      }
    }

    function setVariableInput (newVal) {
      inputElem.value = formatNumber(newVal, false)
      newVal = unformatNumber(newVal)
      setTopLevelValue(newVal, sliderId.split('-')[1])
      setSliderBg()
    }

    // smooth slider value change
    function setSlider () {
      if (sliderInterval) {
        clearInterval(sliderInterval)
      }

      sliderInterval = setInterval((() => {
        const sliderValueInt = parseInt(sliderElem.value, 10)
        const sliderStepInt = parseInt(sliderElem.step, 10)
        setSliderBg()

        if (Math.abs(sliderValueInt - val) < sliderStepInt) {
          clearInterval(sliderInterval)
        } else {
          if (sliderValueInt > val) {
            sliderElem.value = sliderValueInt - sliderStepInt
          } else if (sliderValueInt < val) {
            sliderElem.value = sliderValueInt + sliderStepInt
          } else {
            sliderElem.value = val
          }
        }
      }), 1)
    }

    function setSliderBg () {
      const sliderMin = parseInt(sliderElem.min, 10)
      const sliderMax = parseInt(sliderElem.max, 10)
      const sliderRect = sliderElem.getBoundingClientRect()
      const posLeft = (sliderElem.value - sliderMin) / (sliderMax - sliderMin)
      sliderElem.style.backgroundPositionX = sliderRect.width * posLeft + (-1 * sliderRect.width) + 'px'
    }

    function setTopLevelValue (newVal, name) {
      switch (name) {
        case 'money':
          moneyValue = parseFloat(newVal, 10)
          val = moneyValue
          break
        case 'goal':
          goalValue = parseFloat(newVal, 10)
          val = goalValue
          break
        default:
          console.error('Error while setting cfo calculator top level value')
          break
      }

      getOffer()
    }

    const sliderElem = document.getElementById(sliderId)
    const inputElem = document.getElementById(inputId)

    if (sliderElem && inputElem) {
      setVals(sliderElem, def, min, max, step)
      setVals(inputElem, def, min, max, step)
      sliderElem.addEventListener('input', e => setVariableInput(e.target.value))
      sliderElem.addEventListener('change', e => setVariableInput(e.target.value))
      inputElem.addEventListener('input', e => setVariableSlider(e.target.value))
      inputElem.addEventListener('change', e => setVariableSlider(e.target.value))
      inputElem.addEventListener('blur', e => {
        const valAsNo = unformatNumber(e.target.value)
        if (valAsNo < min) {
          setTopLevelValue(min, sliderId.split('-')[1])
          e.target.value = formatNumber(min)
        } else if (valAsNo > max) {
          setTopLevelValue(max, sliderId.split('-')[1])
          e.target.value = formatNumber(max)
        } else {
          inputElem.value = formatNumber(inputElem.value, false)
        }
        setVariableSlider(e.target.value)
      })

      setSliderBg()
      window.addEventListener('resize', () => setSliderBg(), { passive: true })

      if (inputElem.nextSibling) {
        inputElem.parentNode.removeChild(inputElem.nextSibling)
      }
    }
  }

  if (document.getElementById('cfo-calculator-form')) {
    moneyMin = cleanLabels('moneyMin', 500)
    moneyMax = cleanLabels('moneyMax', 25000)
    goalMin = cleanLabels('goalMin', 15)
    goalMax = cleanLabels('goalMax', 90)

    moneyValue = moneyDefault
    goalValue = goalDefault

    initializeElements('cfo-money-slider', 'cfo-money-input', moneyDefault, moneyMin, moneyMax, moneyStep, moneyValue)
    initializeElements('cfo-goal-slider', 'cfo-goal-input', goalDefault, goalMin, goalMax, goalStep, goalValue)
    await getOffer()

    if (document.getElementById('cfo-modal-button')) {
      document.getElementById('cfo-modal-button').onclick = () => $('#cfo-modal').modal('show')
    }

    const locale = getCountry()

    if (locale.includes('ch')) {
      defaultCurrency = 'CHF'
    } else if (locale && (locale.includes('gb') || locale.includes('uk'))) {
      defaultCurrency = 'GBP'
    } else {
      defaultCurrency = 'EUR'
    }

    document.getElementById('cfo-currency').innerText = defaultCurrency
    document.getElementById('cfo-calculator-form').onsubmit = (e) => {
      document.getElementById('cfo-submit').click()
      e.preventDefault()
    }
  }
}

const format = getCountry()
const thousandSeperator = format === 'gb' ? ',' : format === 'ch' ? '\'' : '.'
const decimalSeperator = format === 'gb' || format === 'ch' ? '.' : ','

function formatNumber (number, endingZero = false) {
  if (!number) {
    number = ''
  }

  const noArrayDecimal = number.toString().replaceAll(thousandSeperator, '').split(decimalSeperator)

  noArrayDecimal[0] = noArrayDecimal[0].replaceAll(/\B(?=(\d{3})+(?!\d))/g, thousandSeperator)

  if (endingZero) {
    if (noArrayDecimal.length === 1) {
      noArrayDecimal.push('')
    }
    if (noArrayDecimal[1].length === 0) {
      noArrayDecimal[1] += '0'
    }
    if (noArrayDecimal[1].length === 1) {
      noArrayDecimal[1] += '0'
    }
  }

  return noArrayDecimal.join(decimalSeperator)
}

function unformatNumber (number) {
  if (typeof number === 'number') {
    return number
  } else if (!number) {
    number = 0
  }

  return parseFloat(number.toString().replaceAll(thousandSeperator, ''))
}

async function getOffer () {
  // staging urls don't work as of 15-12-2020
  const isStaging = false

  const apiUrl = 'https://app.cashflowoptimizer.com/api/generateQuickOfferFrontend'
  const calcUrl = 'https://app.cashflowoptimizer.com/#/welcome'
  const stagingApiUrl = 'https://ontimefactoring-cfo2.azurewebsites.net/api/generateQuickOffer'
  const stagingCalcUrl = 'https://ontimefactoring-cfo2.azurewebsites.net/#/welcome'

  function renderResult (data = {}) {
    function placeCurrency (newVal, id) {
      const elem = document.getElementById(id)
      if (elem) {
        if (defaultCurrency === 'CHF' || defaultCurrency === 'GBP') {
          elem.innerText = defaultCurrency + ' ' + formatNumber(newVal, true)
        } else {
          elem.innerText = formatNumber(newVal, true) + ' ' + defaultCurrency
        }
      }
    }

    if (data.currency) {
      const calcEl = document.getElementsByClassName('cfo-calculator')[0]
      defaultCurrency = data.currency

      Array.from(calcEl.classList).filter(cl => cl.toString().includes('currency-')).forEach(cl => calcEl.classList.remove(cl))
      calcEl.classList.add(`currency-${defaultCurrency}`)
    }

    placeCurrency(data.commission.toString().replace('.', decimalSeperator), 'cfo-commission')
    placeCurrency(data.firstPayment.toString().replace('.', decimalSeperator), 'cfo-within24')
    placeCurrency(data.totalPayment.toString().replace('.', decimalSeperator), 'cfo-payout')
  }

  function createCalculatorLink () {
    //different locale format
    const locale = getLocale().replace('_', '-')
    const country = getCountry()

    return `${isStaging ? stagingCalcUrl : calcUrl}?lang=${locale}&amount=${moneyValue}&currency=${defaultCurrency}&countryid=${country}`
  }

  if (dataTimeout) {
    clearTimeout(dataTimeout)
  }

  dataTimeout = setTimeout(() => {
    $.ajax({
      url: isStaging ? stagingApiUrl : apiUrl,
      method: 'POST',
      data: JSON.stringify({
        amount: moneyValue,
        deadlineInDays: goalValue,
        countryid: getCountry()
      }),
      contentType: 'application/json'
    }).then((data, status) => {
      //console.debug("Calculator got request data", data);
      //only render if this is the latest request
      renderResult(data)
    }).then(() => {
      document.getElementById('cfo-submit').href = createCalculatorLink()
    })
  }, 500)
}

export default {
  init
}
